module.exports = __webpack_public_path__ + "img/渤海.6a6a607e.png";